// Props
export interface FileUploadComponentProps {
	title?: string; // Label
	style?: React.CSSProperties; // Component Styling
	placeholder?: string; // Placeholder
	maxFileSize: string; // Accepted File Size
	allowedExtensions: ExtensionKey[]; // File Extensions
	defaultUrl?: string; // Default Value (e.g., "https://example.com/file.pdf")
    dimensions?: Dimension[]; // Image Dimensions
	multiple?: boolean; // Accepts Multiple Input
	maxFileCount?: number; // Max File Count
	isRequired?: boolean; // Required
	isDisabled?: boolean; // Disabled
	onChange?: (fileData: FileData[] | null) => void; // On Change Event (File Upload)
	onError?: (error: string) => void; // On Error Event (File Upload)
}

export interface Dimension {
	width: number;
    height: number;
}

export interface FileUploadProps {
	maxFileSize: string;
	multiple?: boolean;
	maxFileCount?: number;
	defaultUrl?: string;
    dimensions?: Dimension[];
	allowedExtensions: ExtensionKey[];
	onChange?: (fileData: FileData[] | null) => void;
	onError?: (error: string) => void;
}

export interface FileData {
	id: string; // Unique identifier (stable React key, independent of file name)
	name: string; // File Name
	size: number; // File Size
	type: string; // File Type
	url: string; // File URL
	file: File | null; // File Object
}

export interface FileUrl {
	name: string;
	type: string;
	url: string;
}

export interface FileValidationResult {
	filename: string;
	message: string;
}

export const formatToMimeType: Record<string, string> = {
	// Image Formats
	"jpeg": "image/jpeg",
	"jpg": "image/jpg",
	"png": "image/png",
	"gif": "image/gif",
	"bmp": "image/bmp",
	"webp": "image/webp",
	// Document Formats
	"pdf": "application/pdf",
	// Presentation Formats
	"ppt": "application/vnd.ms-powerpoint",
	"pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	// Word Formats
	"doc": "application/msword",
	"docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	// Spreadsheet Formats
	"xls": "application/vnd.ms-excel",
	"xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const ExtensionList = {
	Image: ["jpeg", "jpg", "png", "gif", "bmp", "webp"] as const,
	Presentation: ["ppt", "pptx"] as const,
	Word: ["doc", "docx"] as const,
	Document: ["pdf"],
	Spreadsheet: ["xls", "xlsx"] as const,
} as const;

type ExtensionKey = keyof typeof formatToMimeType;

// Default Values
export const MAX_FILE_SIZE = 10485760; // 10 MB in bytes
export const MAX_VISIBLE_FILES = 10;
export const MAX_FILE_COUNT = 50;